import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Toaster } from 'react-hot-toast';
import Router from './app/Router';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthContextProvider } from './app/context/AuthContext';
import { GlobalLoaderProvider } from './app/context/GlobalLoaderContext';
import { useTheme } from './app/hooks/useTheme';
import { ModalManager } from './app/services/providers/ModalManager';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

export function App() {
  useTheme();

  return (
    <QueryClientProvider client={queryClient}>
      <GlobalLoaderProvider>
        <AuthContextProvider>
          <ModalManager />
          <Toaster />
          <Router />
        </AuthContextProvider>
      </GlobalLoaderProvider>

      <ReactQueryDevtools position="bottom" />
    </QueryClientProvider>
  );
}
